import { AuthErrorCodeKey } from 'shared/src/models/authErrorCode';
import { hideAppLoader } from 'shared/src/helpers/dom/domHelper';

let loadIncorrectPerson: (errorCode?: AuthErrorCodeKey) => void;
let loadOrganization: () => void
let loadUser: () => void

// Development mode nie używa module federation, żeby umożliwić hot reload
// @ts-ignore
if (import.meta.env.MODE  === 'development') {
  loadOrganization = () => {
    // @ts-ignore
    import('https://localhost:8083/eus_organization/src/createOrganizationApp.ts');
  };

  loadUser = () => {
    // @ts-ignore
    import('https://localhost:8082/eus_user/src/createUserApp.ts');
  };

  loadIncorrectPerson =  async (errorCode?: AuthErrorCodeKey) => {
    try {
      // @ts-ignore
      let module = await import('https://localhost:8102/incorrect_person/src/createIncorrectPersonApp.ts');
      const incorrectPersonApp = module.default(errorCode);
      incorrectPersonApp.mount('#app');
    } catch (error) {
      console.error('Błąd podczas ładowania incorrectPerson:', error);
    } finally {
      hideAppLoader();
    }
  };
} else {
  loadOrganization = () => {
    import('eus_organization/createOrganizationApp');
  };

  loadUser = () => {
    import('eus_user/createUserApp');
  };

  loadIncorrectPerson = (errorCode?: AuthErrorCodeKey) => {
    //@ts-ignore
    import('incorrect_person/createIncorrectPersonApp')
      .then((res) => {
        const incorrectPersonApp = res.default(errorCode);
        if(!incorrectPersonApp) {
          throw new Error('incorrectPerson app instance not found');
        }
        incorrectPersonApp.mount('#app');
      })
      .catch(error => {
        console.log(error);
      })
      .finally(hideAppLoader);
  }
}

export { loadOrganization, loadUser, loadIncorrectPerson }
